var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"icon",attrs:{"draggable":"true"},on:{"dragstart":function($event){return _vm.dragStart(_vm.icon, $event)}}},[_c('img',{attrs:{"draggable":"false","title":_vm.icon.name,"src":_vm.icon.image}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-05d0d40f","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/popup-window/draggable-icon.vue
// module id = null
// module chunks = 